import React from 'react';

import { widgetEnum } from '../../../../utils/constants.ts';
import type { PluginConfig } from '../config-schema.ts';
import MapPanControlsDesktop from './MapPanControlsDesktop.tsx';
import MapPanControlsMobile from './MapPanControlsMobile.tsx';

const MAP_PAN_CONTROLS_DESKTOP = 'mapPanControlsDesktop';
const MAP_PAN_CONTROLS_MOBILE = 'mapPanControlsMobile';
/** Pixels for each pan offset */
const PAN_DELTA = 150;

const createDesktopController = async app => {
  app.bus.send('layers/register', {
    id: MAP_PAN_CONTROLS_DESKTOP,
    widget: () => <MapPanControlsDesktop bus={app.bus} T={app.gt()} delta={PAN_DELTA} />,
    show: true,
    isOverlay: true,
    layoutId: 'buttonOptions',
    widgetType: widgetEnum.Desktop,
    order: 20,
  });
};

const createMobileController = async app => {
  app.bus.send('layers/register', {
    id: MAP_PAN_CONTROLS_MOBILE,
    widget: () => <MapPanControlsMobile bus={app.bus} T={app.gt()} delta={PAN_DELTA} app={app} />,
    shouldShow: currentlyShowing => {
      if (currentlyShowing.includes('SearchResultsBody') && currentlyShowing.includes('SearchResultsHeader')) {
        return true;
      }
      const widgetsToCheck = ['SearchResultsHeader'];
      return !widgetsToCheck.some(widget => currentlyShowing.includes(widget));
    },
    isOverlay: true,
    layoutId: 'mapControls',
    widgetType: widgetEnum.Mobile,
    order: 40,
  });
};

function create(app, config: PluginConfig & { hide?: boolean }) {
  const init = () => {};

  if (!config.hide) {
    createDesktopController(app);
    createMobileController(app);
  }

  return {
    init,
  };
}

export { create };
